import { useCallback } from 'react';
import { useAppTranslation } from '@flowus/common/i18n';
import { useOpenModal } from 'src/common/components/next-modal';
import { createActivityModalAnchor } from './create-activity-modal-anchor';

export const useOpenAllTaskModal = () => {
  const openModal = useOpenModal();
  const { t } = useAppTranslation();

  return useCallback(() => {
    const activityModalAnchor = createActivityModalAnchor();

    openModal.dropdown({
      popcorn: activityModalAnchor.popcorn,
      modalId: 'openStageTaskModal',
      placement: 'top-end',
      offset: [4, 10],
      closeAfterCallBack: activityModalAnchor.remove,
      content: () => (
        <div className="p-7 next-modal w-80">
          <div>
            <div className="text-h3 mb-2.5">{t('components.activities.all_task_modal.title')}</div>
            <div className="text-t1-medium">
              {t('components.activities.all_task_modal.congratulations')}
            </div>
            <div className="text-t1-medium">
              {t('components.activities.all_task_modal.help_tip')}
            </div>
          </div>
          <div className="mt-7 flex items-center"></div>
        </div>
      ),
    });
  }, [openModal, t]);
};
